import { useMemo } from 'react';
import { feachTimeTypeToFilterTimeType } from '@/pages/intelligence/utils/common';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import moment from 'moment';

export const useUpdateFilterFormValues = (props: { formValue: any; timeFilterValues: any }) => {
  const { formValue, timeFilterValues } = props || {};
  /** 时间筛选器值由父组件更新 */
  const combinedValues = useMemo(() => {
    /** 继承值更新 */
    const newFormValue = { ...formValue };
    /** 时间筛选器值由父组件更新 */
    if (Array.isArray(timeFilterValues?.value) && timeFilterValues?.value.length === 2) {
      newFormValue[filterKeyMap.RANGE_TIME] = {
        type: feachTimeTypeToFilterTimeType(timeFilterValues.type),
        value: [moment(timeFilterValues.value[0]), moment(timeFilterValues.value[1])],
      };
    }

    return newFormValue;
  }, [JSON.stringify(formValue), JSON.stringify(timeFilterValues)]);

  return combinedValues;
};
